import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { ImageModule } from '@df/module-image/image.module';
import { OptionImagePipe } from '@df/ui/common/option-image.pipe';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ModalLayoutRightComponent } from 'projects/app-default/src/app/ui/modal/modal-layout-right.component';
import { LocalProduct } from '../../../../model/product/product.decorator';
import { DfModuleImageModule } from '@df/module-image/df-module-image.module';

export namespace NFeatureSectionModal {
    export const featureSectionModalId = 'feature-section-modal';

    export interface IInitiatorData {
        product: LocalProduct<IProductDataV3>;
    }
}

@DfModal({
    id: NFeatureSectionModal.featureSectionModalId,
    position: 'right',
    config: sizeName => ({
        width: { S: '100vw', M: '100vw', L: '32rem', X: '32rem' }[sizeName],
        height: '100vh',
        position: {
            top: '0',
            right: '0',
            bottom: '0'
        },
        maxWidth: '100vw'
    }),
    reopenPolicy: NDfModal.ReopenPolicy.first,
    prerenderAllowed: false,
    sizeRestriction: sizeName => ({ S: ['S', 'M'], M: ['S', 'M'], L: ['L', 'X'], X: ['L', 'X'] })[sizeName]
})
@Component({
    selector: 'feature-section-modal',
    templateUrl: './feature-section-modal.html',
    standalone: true,
    imports: [ModalLayoutRightComponent, TranslationModule, ImageModule, DfModuleImageModule, OptionImagePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeatureSectionModalComponent {
    constructor(
        private modalRef: ModalRef<FeatureSectionModalComponent>,
        @Inject(MODAL_DATA) public data: NFeatureSectionModal.IInitiatorData
    ) {}

    protected close(): void {
        this.modalRef.close();
    }
}
